/* eslint-disable react/prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
// import DefaultLink from './DefaultLink'

const Container = styled.div`
  margin-bottom: 25px;
`
const Title = styled.p`
  font-size: 18px;
  font-weight: bold;
  color: ${(props) => props.theme.highlight};
  margin-bottom: 0;
`

const ProjectAward = ({ title, description }) => (
  <Container>
    <Title>{title}</Title>
    {description}
  </Container>
)

ProjectAward.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
}

export default ProjectAward
